import { BrowserRouter as Router, Route, Switch, useHistory, useLocation } from "react-router-dom";
import "./styles/styles.scss";

import Header from "./components/Header";
import Slider from "./components/Slider";
import Main from "./components/Main";
import Footer from "./components/Footer";
import WhatsAppFlotante from "./components/WhatsAppFlotante/WhatsAppFlotante";

import Error404 from "./components/404";

import TagManager from "react-gtm-module";
import { saveTrackingParams, getSavedTrackingParams, getUtmsQueryString } from "./utils/utmTracker";
import { saveUtmParams } from "./config/whatsappConfig";

import ScrollToTop from "./components/ScrollToTop";
import { useEffect, useState } from "react";
import { getFirestore } from "./config/firebase";
import { AppProvider } from "./config/ToSendProvider";

/**
 * Si la URL perdió params que teníamos guardados (p.ej. por un redirect),
 * los restaura para que la barra de direcciones muestre la URL completa.
 */
function UtmUrlPreserver() {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    saveTrackingParams();
    saveUtmParams();
    const saved = getSavedTrackingParams();
    const currentParams = new URLSearchParams(location.search);
    const savedKeys = Object.keys(saved);

    if (savedKeys.length === 0) return;

    const missingKeys = savedKeys.filter((k) => currentParams.get(k) !== saved[k]);
    if (missingKeys.length > 0) {
      const newSearch = getUtmsQueryString();
      history.replace(`${location.pathname}${newSearch}`);
    }
  }, [location.pathname, location.search, history]);

  return null;
}

function App() {
  useEffect(() => {
    // Capturar UTMs del link de llegada lo antes posible
    saveTrackingParams();
    saveUtmParams();

    const tagManagerArgs = {
      gtmId: "G-HXNHVTFG7J",
    };

    TagManager.initialize(tagManagerArgs);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
    });
  }, []);

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const vehicles = db.collection("fiat");
  //   vehicles.get().then((querySnapshot) => {
  //     setVehicles(querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  //   });
  // }, []);

  useEffect(() => {
    const cargarVehiculos = async () => {
      const datosLocales = sessionStorage.getItem("vehicles-fiat");
      if (datosLocales) {
        setVehicles(JSON.parse(datosLocales));
        setLoading(false);
      } else {
        const db = getFirestore();
        const vehicles = db.collection("fiat");
        try {
          const querySnapshot = await vehicles.get();
          const vehiclesData = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
          sessionStorage.setItem("vehicles-fiat", JSON.stringify(vehiclesData));
          setVehicles(vehiclesData);
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      }
    };

    cargarVehiculos();
  }, []);

  return (
    <AppProvider>
      <Router basename="/fiat">
        <UtmUrlPreserver />
        <ScrollToTop />
        <Switch>
          <Route exact path="/:tipo?">
            <Header vehicles={vehicles} loading={loading} />
            <Slider />
            <Main vehicles={vehicles} loading={loading} />
            <Footer />
            <WhatsAppFlotante />
          </Route>

          <Route path="*">
            <Error404 />
          </Route>
        </Switch>
      </Router>
    </AppProvider>
  );
}

export default App;
